import { getUserConfigAPI } from '../sevices/configService';

export const getUserConfig = () => async (dispatch) => {
  await dispatch(getUserConfigAPI());
};